function locationClass(stay: any): string {
    // Accepts stay: any because this method is also used on the Stroke Unit table
    // where not all rows necessarily have a stay
    if (stay.good === true) return 'dashboard-good-stay' 
    if (stay.good === false) return 'dashboard-breach-stay'
    return ''
}

export { locationClass }
